export default [
	{
		path: '/personal/index',
		component: resolve => require(['@/components/personal/index'], resolve),
		meta: {
			title: '票务预约',
	    	notNeedlogin: true
		}
	},
	{
		path: '/personal/fillInfo',
		component: resolve => require(['@/components/personal/fillInfo'], resolve),
		meta: {
			title: '票务预约',
			notNeedlogin: true
		}
	},
	{
		path: '/personal/confirminfo',
		component: resolve => require(['@/components/personal/confirmInfo'], resolve),
		meta: {
			title: '票务预约'
		}
	},
	{
		path: "/personal/applyresult",
		component: resolve => require(["@/components/personal/applyresult"], resolve),
		meta: {
			title: '票务预约'
		}
	},
	{
		path: "/personal/orderrecord",
		component: resolve => require(["@/components/personal/orderRecord"], resolve),
		meta: {
			title: '票务预约'
		}
	},
	{
		path: "/personal/orderdetail",
		component: resolve => require(["@/components/personal/orderDetail"], resolve),
		meta: {
			title: '票务预约'
		}
	}
]


// WEBPACK FOOTER //
// ./src/router/personal/index.js